// Ticket types that are added to the order automatically and must never be
// deletable by the customer directly, nor left over alone in the basket.
const NON_DELETABLE_TICKET_BY_EXTERNALCODES = ["school companion", "city rally introduction"];

export default NON_DELETABLE_TICKET_BY_EXTERNALCODES;
